import { render } from "./UploadProductCogsDataSidebar.vue?vue&type=template&id=62aa12eb&scoped=true"
import script from "./UploadProductCogsDataSidebar.vue?vue&type=script&lang=js"
export * from "./UploadProductCogsDataSidebar.vue?vue&type=script&lang=js"

import "./UploadProductCogsDataSidebar.vue?vue&type=style&index=0&id=62aa12eb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62aa12eb"]])

export default __exports__